import { useLocalStorage } from 'hooks/useLocalStorage'
import { GlobalMessageSetting } from 'model'
import {
  IButtonStyles,
  IMessageBarStyles,
  MessageBar,
  MessageBarButton,
  MessageBarType,
} from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useGlobalMessageSettingQuery } from './GlobalMessage.generated'

const MessageBarStyles: IMessageBarStyles = {
  root: { flexDirection: 'row' },
  actions: {
    margin: '4px 12px 4px 8px',
  },
}

const MessageBarButtonStyles: IButtonStyles = {
  root: { width: '180px' },
}

const MessageComponent: React.FC<{ message: string }> = ({ message }) => {
  const { t } = useTranslation()

  let isNewMessage = false
  const [currentMessage, setCurrentMessage] = useLocalStorage(
    'currMessage',
    'feea846c-6f5e-42e2-98fc-c1a974b854c5'
  )
  isNewMessage = currentMessage !== message
  const [hideMessage, setHideMessage] = useLocalStorage('hideMessage', false)
  if (isNewMessage) {
    setHideMessage(false)
    setCurrentMessage(message)
  }

  const onHideMessageClick = React.useCallback(() => {
    setHideMessage(true)
  }, [setHideMessage])

  if (hideMessage) {
    return <></>
  }

  return (
    <MessageBar
      messageBarType={MessageBarType.severeWarning}
      styles={MessageBarStyles}
      actions={
        <MessageBarButton
          styles={MessageBarButtonStyles}
          onClick={onHideMessageClick}
        >
          {t('action.doNotShowAgain')}
        </MessageBarButton>
      }
    >
      {message}
    </MessageBar>
  )
}

export const GlobalMessage: React.FC = () => {
  let message = ''
  let isActive = false

  const { data, loading } = useGlobalMessageSettingQuery()
  const globalMessageSetting: GlobalMessageSetting | undefined =
    data && data.globalSettingByType ? data.globalSettingByType : undefined

  if (globalMessageSetting && globalMessageSetting.globalMessage) {
    message = globalMessageSetting.globalMessage.message || ''
    isActive = globalMessageSetting.globalMessage.isActive
  }

  if (!message || !isActive || loading) {
    return <></>
  }

  return <MessageComponent message={message} />
}
